ht.declare('.js-dependentSelect', function () {
  ht.dependentSelect(this, $(this).data('dependentSelectOpts'));
});
